<template>
    <div class="upload-material-container">
        <div class="viewer" v-show="!guid || auditstatus == '1'">
            <div class="left-viewer">
                <div class="preview-viewer" v-if="formData.material">
                    <iframe :src="formData.material.previewurl" frameborder="0"></iframe>
                    <div class="preview-bottom-mask">
                        <span class="reupload" @click="reupload">
                            <i class="el-icon-refresh-right"></i>
                            重新上传</span
                        >
                    </div>
                </div>
                <el-upload
                    v-show="!formData.material"
                    ref="uploader"
                    class="uploader"
                    accept=".doc,.docx"
                    :data="uploadParams"
                    :action="uploadMaterialUrl"
                    :show-file-list="false"
                    :on-success="handleMaterialSuccess"
                    :before-upload="beforeMaterialUpload"
                >
                    <div class="upload-picker">
                        <div><i class="el-icon-upload2"></i>上传素材</div>
                        <p>
                            上传后自动读取相关信息，文件大小≤50MB
                        </p>
                    </div>
                </el-upload>
            </div>
            <div class="right-viewer">
                <el-form :model="formData" :rules="formRules" ref="form" size="small">
                    <el-form-item>
                        <el-form-item label="素材标题" prop="title" class="required">
                            <el-input v-model="formData.title" placeholder="请输入" maxlength="500"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="素材类型" prop="type" class="required">
                            <el-cascader
                                @change="getMaterialTags()"
                                style="width: 100%;"
                                v-model="formData.type"
                                :options="materialTypesOptions"
                                :props="{ expandTrigger: 'hover' }"
                            ></el-cascader>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="标签" prop="tag" class="required">
                            <el-select
                                style="width: 100%;"
                                v-model="formData.tag"
                                ref="tags"
                                multiple
                                filterable
                                :filter-method="filterTags"
                                placeholder="请选择"
                                @change="
                                    () => {
                                        searchTagKeyword = '';
                                    }
                                "
                            >
                                <template #empty>
                                    <div class="custom-empty">
                                        <a href="javascript:" class="add-tag" @click="addTag" :title="searchTagKeyword">
                                            + 新增标签 "{{ searchTagKeyword }}"
                                        </a>
                                    </div>
                                </template>
                                <el-option
                                    v-for="item in renderMaterialTagsOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                    <div class="custom-multiple-option" :title="item.label">
                                        {{ item.label }}
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item v-if="showPrice">
                        <el-form-item label="素材价格" prop="saleprice" class="required">
                            <el-input-number
                                v-model="formData.saleprice"
                                controls-position="right"
                                :min="0"
                                :precision="2"
                                size="small"
                                placeholder="请输入"
                            ></el-input-number>
                            <p style="margin-top:5px;">
                                <span v-if="formData.type">推荐素材定价范围 ¥ {{ pricerange.join('~') }}，</span>
                                {{ masterInfo.publisher.publishertype | publishertype }}认证用户分润为售价的{{
                                    masterInfo.publisher.publishertype === 'enterprise' ? '60' : '50'
                                }}%
                            </p>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="页数">
                            {{ formData.pagesize ? formData.pagesize + ' 页' : '--' }}
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="viewer" v-if="!(!guid || auditstatus == '1')">
            <div class="left-viewer">
                <div class="preview-viewer" v-if="formData.material">
                    <iframe :src="formData.material.previewurl" frameborder="0"></iframe>
                </div>
            </div>
            <div class="right-viewer">
                <div class="state state1" v-if="auditstatus == '2'">
                    <div class="state-text">审核中</div>
                </div>
                <div class="state state2" v-else-if="auditstatus == '5'">
                    <div class="state-text">已上架</div>
                </div>
                <div class="state state3" v-else-if="auditstatus == '4'">
                    <div class="state-text">审核不通过</div>
                    <p>{{ formData.auditbackreason }}</p>
                </div>
                <div class="state state4" v-else-if="auditstatus == '6'">
                    <div class="state-text">已下架</div>
                </div>
                <el-form size="small">
                    <el-form-item>
                        <el-form-item label="素材标题" prop="title" class="required">
                            {{ formData.title }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item v-if="formData.materialno">
                        <el-form-item label="素材编号" prop="materialno" class="required">
                            {{ formData.materialno }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="素材类型" prop="type" class="required">
                            {{ getType(formData.type) }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="标签" prop="tag" class="required">
                            <el-tag v-for="item in formData.tag" size="mini" :key="item">
                                {{ item }}
                            </el-tag>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="素材价格" prop="saleprice" class="required">
                            <p>￥{{ formData.saleprice }}</p>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="页数" prop="pagesize"> {{ formData.pagesize }} 页</el-form-item>
                    </el-form-item>
                    <el-form-item v-if="auditstatus == '2' || auditstatus == '4'">
                        <el-form-item label="提交审核时间">
                            {{ formData.releasedate }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item v-if="auditstatus == '5' || auditstatus == '6'">
                        <el-form-item label="购买量"> {{ formData.buynum }} 份</el-form-item>
                    </el-form-item>
                    <el-form-item v-if="auditstatus == '5' || auditstatus == '6'">
                        <el-form-item label="上架时间">
                            {{ formData.shelvedate }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item v-if="auditstatus == '6'">
                        <el-form-item label="下架时间">
                            {{ formData.takedowndate }}
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="footer" v-if="!guid || (auditstatus && auditstatus == '1')">
            <el-button type="primary" @click="submit('add')" size="small">确定</el-button>
            <el-button size="small" @click="submit('save')">保存草稿</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
        </div>
        <div class="footer" v-if="guid && auditstatus && auditstatus == '5'">
            <el-button type="primary" @click="tabedownMaterial()" plain size="small">下架</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
        </div>
        <div class="footer" v-if="guid && auditstatus && auditstatus == '2'">
            <el-button type="primary" @click="revocationMaterial()" size="small">撤回审核申请</el-button>
        </div>
        <div class="footer" v-if="guid && auditstatus && auditstatus == '4'">
            <el-button type="primary" @click="editMaterial()" size="small">编辑</el-button>
            <!--            <el-button type="primary" @click="deleteMaterial()" plain size="small">删除</el-button>-->
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import {getMaterialTypesData} from '@/util/util';
import {createGuid, getFileNameExtension} from '@/util/util';

export default {
    name: 'UploadMaterialDialog',
    props: {
        guid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            rowguid: '',
            auditstatus: '',
            form: null,
            formData: {
                material: null,
                title: '',
                type: '',
                tag: [],
                saleprice: ''
            },
            formRules: {
                title: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                type: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'change'
                    }
                ],
                tag: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'change'
                    }
                ],
                saleprice: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ]
            },
            materialTypesOptions: [],
            materialTagsOptions: [],
            renderMaterialTagsOptions: [],
            pricerange: [],
            uploadMaterialUrl: '',
            masterInfo: {
                publisher: {}
            },
            searchTagKeyword: '',
            uploadParams: {
                cliengguid: '',
                clienttag: 'materialdoc'
            },
            uploadLoading: null,
            showPrice: false
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    filters: {
        publishertype(val) {
            let text = '个人';
            if (val === 'enterprise') {
                text = '企业';
            }
            return text;
        }
    },
    mounted() {
        this.rowguid = createGuid();
        this.uploadMaterialUrl = window.service.uploadMaterialAttach.url;
        this.getMaterialTypes();
        this.getMasterInfo();
        this.form = this.$refs.form;
        if (this.guid) {
            this.getDetail();
        }
        if (this.$refs.tags) {
            this.$refs.tags.$el.querySelectorAll('input')[0].setAttribute('maxlength', 8)
        }
    },
    methods: {
        getMaterialTypes() {
            this.$Api.getMaterialTypes().then((data) => {
                this.materialTypesOptions = getMaterialTypesData(data);
            });
        },
        getMasterInfo() {
            this.$Api
                .getMasterInfo({
                    userguid: this.userInfo.userguid,
                    shopguid: '',
                    ishomepage: '1'
                })
                .then((data) => {
                    this.masterInfo = data;
                });
        },
        getType(data) {
            if (!data) return '';

            // 如果传入的是字符串，先找到父级
            if (typeof data === 'string') {
                let result = [];
                // 遍历查找父子关系
                for (let item of this.materialTypesOptions) {
                    if (item.children) {
                        for (let child of item.children) {
                            if (child.value === data) {
                                result = [item.label, child.label];
                                break;
                            }
                        }
                    }
                }
                return result.join('/');
            }

            // 如果传入的是数组，保持原有逻辑
            let text = [];
            const findLabel = (options, value, level) => {
                for (let item of options) {
                    if (item.value === value[level]) {
                        text.push(item.label);
                        if (item.children && level < value.length - 1) {
                            findLabel(item.children, value, level + 1);
                        }
                        break;
                    }
                }
            };

            if (Array.isArray(data)) {
                findLabel(this.materialTypesOptions, data, 0);
            }
            return text.join('/');
        },
        getMaterialTags(cb) {
            this.formData.tag = [];
            let type = Array.isArray(this.formData.type) ? this.formData.type : [this.formData.type];
            let typecode = type[type.length - 1];
            // 选择了素材类型才会显示素材价格
            if (typecode !== '') {
                this.showPrice = true;
            } else {
                this.showPrice = false;
            }

            this.$Api
                .getMaterialTags({
                    typecode
                })
                .then((data) => {
                    this.materialTagsOptions = data.tags.map((item) => {
                        return {
                            label: item,
                            value: item
                        };
                    });
                    this.renderMaterialTagsOptions = this.materialTagsOptions.map((e) => e);
                    this.pricerange = data.pricerange;
                    cb && cb();
                });
        },
        getDetail() {
            this.$Api
                .getMaterialDetail({
                    materialguid: this.guid
                })
                .then((data) => {
                    this.rowguid = data.rowguid;
                    this.auditstatus = data.auditstatus;
                    this.formData.materialno = data.materialno;
                    this.formData.auditbackreason = data.auditbackreason;
                    this.formData.material = {
                        previewurl: data.previewpdfurl,
                        attachguid: data.fileguid
                    };
                    this.formData.title = data.materialtitle;
                    this.formData.type = data.materialtype;
                    this.getMaterialTags(() => {
                        this.formData.tag = data.materialtag.split(';');
                    });
                    this.formData.saleprice = data.saleprice;
                    this.formData.pagesize = data.pagesize;
                    this.formData.releasedate = data.releasedate;
                    this.formData.buynum = data.buynum;
                    this.formData.shelvedate = data.shelvedate;
                    this.formData.takedowndate = data.takedowndate;
                });
        },
        handleMaterialSuccess(res, file) {
            this.uploadLoading && this.uploadLoading.close();
            this.uploadParams.cliengguid = '';
            if (res.code != 200 && res.code != 1) {
                this.$message.error(res.msg);
                return;
            }
            let data = res.data;
            const reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = () => {
                // const base64 = reader.result;
                this.$set(this.formData, 'material', data);
                let title = file.name.replace(/\.[^/.]+$/, '');
                this.formData.title = title;
                this.formData.pagesize = data.pagesize || '';
                this.formData.material.attachguid = data.attachguid;
            };
        },
        beforeMaterialUpload(file) {
            this.uploadParams.cliengguid = this.rowguid;
            let extension = getFileNameExtension(file.name);
            const isDoc = extension === 'doc' || extension === 'docx' || extension === 'word';
            if (!isDoc) {
                this.$message.error('只能上传 doc 或 docx 格式的文件!');
                return false;
            }
            const isLt100M = file.size / 1024 / 1024 <= 50;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 50MB!');
                return false;
            }
            this.uploadLoading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            return true;
        },
        submit(type) {
            if (!this.formData.material) {
                this.$message({
                    type: 'error',
                    message: '请上传素材'
                });
            }
            this.form.validate().then(() => {
                let materialtype = Array.isArray(this.formData.type)
                    ? this.formData.type[this.formData.type.length - 1]
                    : this.formData.type;
                let data = {
                    rowguid: this.rowguid,
                    materialguid: this.guid,
                    relationguid: this.userInfo.userguid,
                    relationtype: this.masterInfo.publisher.publishertype,
                    fileguid: this.formData.material.attachguid,
                    materialtitle: this.formData.title,
                    materialtype,
                    materialtag: this.formData.tag.join(';'),
                    saleprice: this.formData.saleprice,
                    guid: this.guid,
                    auditstatus: type === 'save' ? '1' : '2',
                    pagesize: this.formData.pagesize
                };
                if (this.formData.material) {
                    this.$Api
                        .submitUploadMaterial(data, {
                            showLoading: true
                        })
                        .then((data) => {
                            this.$message({
                                type: data.state,
                                message: data.message
                            });
                            if (data.state === 'success') {
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        reupload() {
            this.$refs.uploader.$el.querySelector('input').click();
        },
        tabedownMaterial() {
            this.$confirm('下架后无法再次上架，已有收益不受影响，请再次确认', '操作确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$Api
                    .takedownMaterial({
                        materialguid: this.guid
                    })
                    .then((data) => {
                        this.$message({
                            type: data.state,
                            message: data.message
                        });
                        if (data.state === 'success') {
                            this.closeDialog();
                        }
                    });
            });
        },
        revocationMaterial() {
            this.$confirm('确定撤回审核申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$Api
                    .revocationMaterial({
                        materialguid: this.guid
                    })
                    .then((data) => {
                        this.$message({
                            type: data.state,
                            message: data.message
                        });
                        if (data.state === 'success') {
                            this.closeDialog();
                        }
                    });
            });
        },
        editMaterial() {
            this.auditstatus = '1'
        },
        deleteMaterial() {
            this.$confirm('确定删除该素材吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$Api
                    .deleteMaterial({
                        materialguid: this.guid
                    })
                    .then((data) => {
                        this.$message({
                            type: data.state,
                            message: data.message
                        });
                        if (data.state === 'success') {
                            this.closeDialog();
                        }
                    });
            });
        },
        addTag() {
            let data = {
                label: this.searchTagKeyword,
                value: this.searchTagKeyword
            };
            this.materialTagsOptions.push(data);
            this.renderMaterialTagsOptions.push(data);
        },
        filterTags(query) {
            if (query.trim()) {
                if (this.materialTagsOptions.length) {
                    this.renderMaterialTagsOptions = this.materialTagsOptions.map((e) => e);
                } else {
                    this.renderMaterialTagsOptions = [
                        {
                            text: '',
                            value: ''
                        }
                    ];
                }
                this.$nextTick(() => {
                    this.searchTagKeyword = query;
                    this.renderMaterialTagsOptions = this.materialTagsOptions.filter((item) => {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                });
            } else {
                this.renderMaterialTagsOptions = this.materialTagsOptions.map((e) => e);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import './style/upload-material-dialog.scss';
</style>
